const EngagementsIcon = (props: any = {}) => {
    return (
        <svg width="30" height="30" {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="15" fill="#FAA75A" />
            <path d="M11.4375 17.0852L13.6824 14.1675L16.243 16.179L18.4398 13.3438" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="21.0041" cy="9.14477" r="1.44165" fill="#FAA75A" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.1958 8.33594H11.745C9.4864 8.33594 8.08594 9.93548 8.08594 12.1941V18.2558C8.08594 20.5144 9.45894 22.1071 11.745 22.1071H18.1981C20.4566 22.1071 21.8571 20.5144 21.8571 18.2558V12.9767" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default EngagementsIcon